<template>
	<span>
		<label class="checkbox-inline" style="padding-right:20px;" v-if="inline">
			<input type="checkbox" :value="optionValue" :checked="isChecked" @change="updateModel" ref="checkbox">
			<div v-html="optionText"></div>
		</label>

		<div class="checkbox" v-else>
			<label>
				<input type="checkbox" :value="optionValue" :checked="isChecked" @change="updateModel" ref="checkbox">
				<span v-html="optionText"></span>
			</label>
		</div>
	</span>
</template>

<script>
	import Base from './base';

	export default {
		extends: Base,

		props: {
			optionValue: { default: '' },
			optionText: { default: '' },
			inline: { default: true }
		},

		computed: {
			isChecked() {
				if (Array.isArray(this.value)) {
					return this.value.indexOf(this.optionValue) !== -1;
				} else {
					if (this.optionValue) {
						return this.value === this.optionValue;
					} else {
						return this.value;
					}
				}
			}
		},

		methods: {
			updateModel($event) {
				let values = [...this.value];

				if (Array.isArray(this.value)) {
					if ($event.target.checked) {
						values.push($event.target.value);
					} else {
						values.splice(values.indexOf($event.target.value), 1);
					}
				} else {
					values = $event.target.checked;
				}

				this.$emit('input', values);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// checkbox.vue?6461113e